import { apiCall } from "@/setup/webApi";
import moment from "moment";

export const FILTER_FIELDS = [
  { title: "Organization", value: "OrganizationId" },
  { title: "Section", value: "SectionId" },
  { title: "Rank", value: "RankId" },
  { title: "Status", value: "StatusId" },
  { title: "Role", value: "RoleId" },
  { title: "Gender", value: "Gender" },
  { title: "Age", value: "Age" },
  { title: "Is BGI", value: "IsBGI" },
  { title: "Is Fee Paid", value: "IsFeePaid" },
];

export const FILTER_OPERATORS = ["=", "!=", ">", "<", ">=", "<="];

export const REGISTRATION_STATUSES = [
  { title: "Pending Incharge", value: "PendingIncharge" },
  { title: "Pending Central", value: "PendingCentral" },
  { title: "Approved", value: "Approved" },
  { title: "Rejected", value: "Rejected" },
];

export function isMiqaatRegistrationOpen(miqaat) {
  if (!miqaat || miqaat.isActive === false) return false;
  const today = moment().startOf("day");
  return today.isSameOrAfter(moment(miqaat.registrationStartDate).startOf("day"))
    && today.isSameOrBefore(moment(miqaat.registrationEndDate).startOf("day"));
}

export const getActive = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/active")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getAll = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/all")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getAvailable = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/available")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getAvailableForIncharge = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/available/incharge")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMiqaat = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${id}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getActiveById = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/active/${id}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMiqaatPreview = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${id}/preview`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const createMiqaat = (payload) => {
  return new Promise((resolve, reject) => {
    apiCall("post", "Miqaat", payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const updateMiqaat = (id, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/${id}`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const updateMiqaatFilters = (id, filters) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/${id}/filters`, { filters })
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const updateMiqaatExclusions = (id, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/${id}/exclusions`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMiqaatSurveys = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${id}/surveys`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const updateMiqaatSurveys = (id, surveys) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/${id}/surveys`, { surveys })
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMiqaatSurveysForMember = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${id}/surveys/for-member`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getRegistrationSurveyForms = (id, timing = "AtRegistration") => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${id}/surveys/registration-forms?timing=${encodeURIComponent(timing)}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const deleteMiqaat = (id) => {
  return new Promise((resolve, reject) => {
    apiCall("delete", `Miqaat/${id}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const register = (id, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("post", `Miqaat/${id}/register`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const registerMember = (id, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("post", `Miqaat/${id}/register-member`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getRegisterableMembers = (miqaatId, search = "") => {
  const query = search ? `?search=${encodeURIComponent(search)}` : "";
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${miqaatId}/incharge/registerable-members${query}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMyRegistrations = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/my-registrations")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const updateTravelDetails = (registrationId, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/travel`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getInchargeRegistrations = (miqaatId) => {
  const query = miqaatId ? `?miqaatId=${miqaatId}` : "";
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/registrations/incharge${query}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getPendingInchargeCount = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/registrations/incharge/pending-count")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getCentralRegistrations = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.miqaatId) params.append("miqaatId", filters.miqaatId);
  if (filters.status) params.append("status", filters.status);
  if (filters.organizationId) params.append("organizationId", filters.organizationId);
  if (filters.itsId) params.append("itsId", filters.itsId);
  const query = params.toString() ? `?${params.toString()}` : "";
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/registrations/central${query}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getRegistrationDetail = (registrationId) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/registrations/${registrationId}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const inchargeApprove = (registrationId) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/incharge-approve`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const moveRegistrationSequence = (registrationId, direction) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/move-sequence`, { direction })
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const reorderRegistrations = (payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", "Miqaat/registrations/reorder", payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const centralApprove = (registrationId) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/central-approve`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const rejectRegistration = (registrationId, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/reject`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const centralReject = (registrationId, payload) => {
  return new Promise((resolve, reject) => {
    apiCall("put", `Miqaat/registrations/${registrationId}/central-reject`, payload)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const getMiqaatRegistrations = (miqaatId) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${miqaatId}/registrations`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const exportMiqaatRegistrations = (miqaatId) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${miqaatId}/registrations/export`, null, true)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const procurement_getItems = () => {
  return new Promise((resolve, reject) => {
    apiCall("get", "Miqaat/procurement/items")
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const procurement_getRights = (miqaatId) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${miqaatId}/procurement/rights`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const procurement_getDetail = (miqaatId, departmentId) => {
  return new Promise((resolve, reject) => {
    apiCall("get", `Miqaat/${miqaatId}/procurement/detail/${departmentId}`)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};

export const procurement_saveDetail = (miqaatId, departmentId, data) => {
  return new Promise((resolve, reject) => {
    apiCall("post", `Miqaat/${miqaatId}/procurement/detail/${departmentId}`, data)
      .then((response) => resolve(response))
      .catch((ex) => reject(ex));
  });
};
